// extracted by mini-css-extract-plugin
export default {"checksLabel":"map-filed_checksLabel__Nt1Ak","headingCentered":"map-filed_headingCentered__SPaTj"};